import { ContractRunner, ethers } from "ethers";
import { contractABI } from "./abi-think";
import { User } from "@/types";
export const THINK_CONTRACT_ADDRESS="0x6e0b07E7A1B550D83E2f11C98Cf1E15fe2b8d47B"

export function getThinkTokenContract(provider: any) {
    return new ethers.Contract(THINK_CONTRACT_ADDRESS, contractABI, provider);
}

export async function getThinkDetails(provider: any, user: User | undefined | null) {
    const astoContract = await getThinkTokenContract(provider)
    const tokenName = await astoContract.name();
    const symbol = await astoContract.symbol();
    const decimals = await astoContract.decimals();
    const balance = user &&  await astoContract.balanceOf(user.address);
    const allowance = user && await astoContract.allowance(user.address, THINK_CONTRACT_ADDRESS);
    const totalSupply = await astoContract.totalSupply();
    return {
        tokenName,
        balance: (Number(balance) / 10 ** Number(decimals)),
        decimals,
        symbol,
        allowance,
        totalSupply
    };
}
